import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/refresh-ccw-01.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M20 12C20 7.58172 16.4183 4 12 4C9.78959 4 7.78979 4.89477 6.34082 6.34473C5.5833 7.10277 4.72436 8.13143 4.03223 9H8C8.55228 9 9 9.44772 9 10C9 10.5523 8.55228 11 8 11H2C1.44772 11 1 10.5523 1 10V4C1 3.44772 1.44772 3 2 3C2.55228 3 3 3.44772 3 4V7.09375C3.6018 6.3619 4.28724 5.5716 4.92676 4.93164C6.7355 3.12166 9.23761 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C7.58213 22 3.83581 19.1359 2.51172 15.165L2.39062 14.7773L2.36719 14.6777C2.27655 14.1791 2.57687 13.6827 3.07422 13.5391C3.60482 13.386 4.15934 13.6921 4.3125 14.2227C5.27565 17.5604 8.35426 20 12 20C16.4183 20 20 16.4183 20 12Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as RefreshCcw01Icon };
